import type { Scopes } from '@atlassian/post-office-context';

export const scopes: Scopes = [
	{
		name: 'all',
		when: {
			route: {
				pathname: {
					matches: '.*',
				},
			},
		},
	},
	{
		name: 'jira/all',
		when: {
			context: { product: 'jira' },
		},
	},
	{
		name: 'jira/kanban',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'board',
				},
			},
		},
	},
	{
		name: 'confluence/all',
		when: {
			context: { product: 'confluence' },
		},
	},
	{
		name: 'pop3/all',
		when: {
			context: { product: 'pop3' },
		},
	},
	{
		name: 'admin/all',
		when: {
			context: {
				product: 'admin',
			},
		},
	},
	{
		name: 'pop3/send-it',
		when: {
			context: { product: 'pop3' },
			route: {
				pathname: {
					matches: 'send-it',
				},
			},
		},
	},
	{
		name: 'admin/products',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'products',
				},
			},
		},
	},
	{
		name: 'trello/all',
		when: {
			context: {
				product: 'trello',
			},
		},
	},
	{
		name: 'jira/queue',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'queue',
				},
			},
		},
	},
	{
		name: 'jira/browse',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'browse',
				},
			},
		},
	},
	{
		name: 'jira/issues',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'issues',
				},
			},
		},
	},
	{
		name: 'jira/backlog',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'backlog',
				},
			},
		},
	},
	{
		name: 'jira/servicedesk',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/servicedesk',
				},
			},
		},
	},
	{
		name: 'jira/project',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: '.*(?=.*project)(?=.*setting).*',
				},
			},
		},
	},
	{
		name: 'jira/your-work',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'your-work',
				},
			},
		},
	},
];
